


































import { Vue, Component } from "vue-property-decorator";
import ClaimViewBaseComponent from "./ClaimViewBaseComponent";
import { IHeader } from "@/store/models/staff/IHeader";
import {
  MailItemDto,
  SearchMailItemInputforStaff,
  MailItemLogDto,
  RetrieveMailItemLogStaffInput
} from "@/asdcom/apiproxy/apiproxy.dto";
import MailItemComponent from "@/components/vcponlineok/staff-user/applicant-mail-component.vue";
import bus from "@/components/vcponlineok/bus/bus.js";

@Component({
  components: {
    MailItemComponent
  }
})
export default class ClaimDocumentsView extends ClaimViewBaseComponent {
  isItemView: boolean = false;
  mailList: MailItemDto[] | undefined = [];
  logList: MailItemLogDto[] = [];
  mailItemModel = new MailItemDto();
  headers: IHeader[] = [
    { text: "Document Name", value: "documentName" },
    { text: "Status", value: "isOpened" },
    { text: "Created", value: "creationTime" }
  ];

  async created() {
    const serachInput = new SearchMailItemInputforStaff({
      claimNumber: this.$route.params.claimNumber
    });
    const ret = await this.$appsvs.staffVpBox.searchMailItems(serachInput);
    this.mailList = ret.items;
  }

  mounted() {
    bus.$on("toListView", () => {
      this.isItemView = false;
    });
  }
  destroyed() {
    bus.$off("toListView");
  }

  async onRowClick(item: MailItemDto) {
    const input = new RetrieveMailItemLogStaffInput({ mailItemId: item.id });
    const ret = await this.$appsvs.staffVpBox.retrieveMailItemLogStaff(input);
    this.logList = ret;
    this.mailItemModel = item;
    this.isItemView = true;
  }
}
